import styled from "styled-components";

const ProfileImage = styled.div<{ image: string }>`
  width: 80px;
  height: 80px;
  border-radius: 40px;
  background: #efefef url(${(props) => props.image}) no-repeat center;
  background-size: 80px;

  @media only screen and (max-width: 768px) {
    width: 64px;
    height: 64px;
    background-size: 64px;
  }
`;

export default ProfileImage;
